import tokenUtil from '@/utils/token'
import * as userApi from '@/api/user'
import * as authApi from '@/api/auth'
import { signpop, INFO } from "@/utils/key.js"

import { LOGIN_TIME } from "@/utils/key.js"
import store from '@/store'
import dayjs from 'dayjs';

import request from '@/ajax'
export default {
    state: {
        info: JSON.parse(localStorage.getItem(INFO)) || null,
        banned: null,
        // isDbGame:null,
        yuntb: false,
        yunFlag: true, // 是否显示云手机tab
        guidanceFlag: false, //是否显示新手引导
        isTishen: false, // 是否提审状态,
        noticeTimer: null, // 消息定时器
        allReadFlag: false, // 消息红点
        gameis_reservation: [], // 游戏预约状态
        homePageState: null,
        yuyueTabIndex: false, // 预约tab
        rolePopupFlag: false, // 角色弹窗
        innerWidth: window.innerWidth, // 屏幕宽度
        newWorkOrderFlag: false, // 新工单通知红点
        isClickSwitch: localStorage.getItem('isGetClick') === 'true' || false, // 点击切换单双卡后，需要重新获取数据
        selectedCommunityGame: (() => {
            try {
                return JSON.parse(localStorage.getItem('selected-community-game') || 'null')
            } catch (e) {
                return null
            }
        })(), // 当前选中的社区游戏（缓存 key 与 uni-new39 一致）
    },

    getters: {
        // 已登录
        logged(state) {
            return Boolean(state.info);
        },

        // 是否已经实名认证
        isRealNameVerified(state) {
            return state.info?.age_status == 1;
        },
        // 是否绑定手机号
        isBingPhoneVerified(state) {
            return state.info?.phone !== ''
        },
        // //是否是单包游戏
        // isgiftcdkDbGame(state) {
        // 	return state.isDbGame == ''
        // },
        // 是否点击切换单双卡
        isClickSwitch(state) {
            return state.isClickSwitch
        },
    },

    mutations: {
        setNewWorkOrderFlag(state, payload) {
            state.newWorkOrderFlag = payload
        },
        setInnerWidth(state, payload) {
            state.innerWidth = payload
        },
        setRolePopupFlag(state, payload) {
            state.rolePopupFlag = payload
        },
        setyuyueTabIndex(state, payload) {
            state.yuyueTabIndex = payload
        },
        saveHomePageState(state, payload) {
            state.homePageState = payload;
        },
        clearHomePageState(state) {
            state.homePageState = null;
        },
        setGameis_reservation(state, obj) {
            // 将obj添加到state.gameis_reservation数组中，如果已经存在相同的game_id则更新is_reservation字段
            let index = state.gameis_reservation.findIndex(item => item.game_id === obj.game_id);
            if (index !== -1) {
                state.gameis_reservation[index].is_reservation = obj.is_reservation;
            } else {
                state.gameis_reservation.push(obj);
            }
        },
        setAllReadFlag(state, payload) {
            state.allReadFlag = payload
        },
        setNoticeTimer(state, payload) {
            if (payload) {
                // 如果定时器已存在，先清除它
                if (state.noticeTimer) {
                    clearInterval(state.noticeTimer);
                    state.noticeTimer = null;
                }
                // 立即执行一次请求
                // request.post('/notice/globalNotice').then(rs => {
                // 	if (rs.code == 200) {
                // 		state.allReadFlag = rs.data
                // 		if(state.allReadFlag){
                // 			store.commit('setNoticeTimer', false)
                // 		}
                // 	}
                // })
                // 创建新的定时器
                state.noticeTimer = setInterval(() => {
                    // 获取当前页面路由
                    const router = require('@/router').default;
                    let currentRoute = router.currentRoute.path;  // 获取当前页面的路由路径
                    if (currentRoute != '/pages/index/index' && currentRoute != '/pages/user/user') return

                    request('/notice/globalNotice').then(rs => {
                        if (rs.code == 200) {
                            state.allReadFlag = rs.data
                            if (state.allReadFlag) {
                                store.commit('setNoticeTimer', false)
                            }
                        }
                    })
                }, 15000)
            } else {
                // 清除定时器
                if (state.noticeTimer) {
                    clearInterval(state.noticeTimer)
                    state.noticeTimer = null
                }
            }
            // 如果用户未登录，确保红点不显示
            if (!state.info) {
                state.allReadFlag = false
            }
        },
        setIsTishen(state, flag) {
            state.isTishen = flag
        },
        setGuidanceFlag(state, flag) {
            state.guidanceFlag = flag
        },
        setYunFlag(state, flag) {
            state.yunFlag = flag
        },
        setSelectedCommunityGame(state, game) {
            state.selectedCommunityGame = game && typeof game === 'object' ? { ...game } : null
            if (state.selectedCommunityGame) {
                localStorage.setItem('selected-community-game', JSON.stringify(state.selectedCommunityGame))
            } else {
                localStorage.removeItem('selected-community-game')
            }
        },
        changeInfo(state, payload) {
            state.info = payload;
            localStorage.setItem(INFO, JSON.stringify(payload))
            console.log(state.info);
        },
        // 系统消息推送
        mergeToInfo(state, payload) {
            state.info = { ...state.info, ...payload };
        },

        changeBanned(state, payload) {
            state.banned = payload;
        },
        // 退出登录 清空信息
        logout(state) {
            state.info = null;
            state.banned = null;
            // uni.removeStorageSync(INFO)
            localStorage.removeItem(INFO)
        },
        setYuntb(state, payload) {
            state.yuntb = payload;
        },
        // 设置点击切换单双卡后，需要重新获取数据
        setIsClickSwitch(state, payload) {
            console.log('payload', payload)
            localStorage.setItem('isGetClick', payload)
            state.isClickSwitch = localStorage.getItem('isGetClick') == 'true' ? true : false
        },
    },

    actions: {
        async getuserHomepage() {
            const res = await userApi.userHomepage({
                customer_id: this.customer_id
            })
            if (res.code == 200) {
                this.homeInfo = res.data
            }
        },
        async getUserInfo({ commit, dispatch, state }) {
            if (!tokenUtil.read()) return;
            const res = await userApi.info();
            if (res.code === 200) {
                const previousCustomerId = state.info && state.info.customer_id;
                let time = dayjs().format('YYYY-MM-DD')
                localStorage.setItem(LOGIN_TIME, time)
                commit('changeInfo', res.data);
                if (String(previousCustomerId) !== String(res.data.customer_id)) {
                    dispatch('loadUserScopedState');
                }

                // syncClientUserInfo() // 同步云手机用户信息

            } else {
                console.log(res);
            }
        },

        /**
         * 修改用户信息，可以只修改其中的某个字段
         */
        async setUserInfo({ dispatch }, payload) {
            const res = await userApi.save(payload);
            if (res.code === 200) {
                await dispatch('getUserInfo');
            }
            return res;
        },

        /**
         * 用户被封禁
         */
        async banned({ commit }, payload) {
            commit('changeBanned', payload);
        },

        /**
         * 使用账号密码登录
         * @param {Object} payload
         * @param {String} payload.username
         * @param {String} payload.password
         */
        //TODO::
        async loginWithUsername({ dispatch, state }, query) {
            const res = await authApi.loginWithUsername(query);
            if (res.code === 200) {
                console.log(9999999999);
                tokenUtil.save(res.data.accessToken);
                await dispatch('getUserInfo');
            }
            return [res, Boolean(state.banned)];
        },
        /**
         * 使用手机号登录
         * @param {Object} payload
         * @param {String} payload.phone		// 手机号
         * @param {String} payload.code			// 验证码
         */
        async loginWithPhoneNumber({ dispatch, state }, { phone, code, params }) {
            const res = await authApi.loginWithPhoneNumber(phone, code, params);
            if (res.code === 200) {
                // #ifdef APP

                try {
                    if (res.data.is_new_account) {
                        RecordNativeModule.registerRecordToNativeSDK(JSON.stringify({ type: 'phone' }))

                    }
                } catch (e) { }

                // #endif
                //TODO::
                tokenUtil.save(res.data.accessToken);
                await dispatch('getUserInfo');

            }
            return [res, Boolean(state.banned)];
        },

        /**
         * 使用Uni的一键登录
         * @param {Object} payload
         * @param {String} payload.openid		// 登录授权唯一标识
         * @param {String} payload.access_token	// 接口返回的 token
         */
        async loginWithUniCloud({ dispatch, state }, { openid, accessToken }) {
            const res = await authApi.loginWithUniCloud(openid, accessToken);
            if (res.code === 200) {
                tokenUtil.save(res.data.accessToken);
                await dispatch('getUserInfo');
            }
            return [res, Boolean(state.banned)];
        },
        /**
         *
         * 使用`闪验`的一键登录
         * @param {object} payload
         * @param {string} payload.token		// 一键登录返回的token
         * @returns {[ApiResponse<object>, boolean]}
         */
        async loginWithShanYan({ dispatch, state }, { token }) {
            const res = await authApi.loginWithShanYan(token);
            if (res.code === 200) {
                // #ifdef APP

                try {
                    if (res.data.is_new_account) {
                        RecordNativeModule.registerRecordToNativeSDK(JSON.stringify({ type: 'phone' }))
                    }
                } catch (e) { }


                // #endif
                tokenUtil.save(res.data.accessToken);
                await dispatch('getUserInfo');
            }
            return [res, Boolean(state.banned)];
        },
        // 退出登录
        async logout({ commit, dispatch }) {
            tokenUtil.clean();
            localStorage.removeItem(INFO)
            commit('logout');
            dispatch('loadUserScopedState');
        },

        /**
         * 切换系统消息推送
         */
        async changeSystemMessagePush({ commit }, payload) {
            const res = await userApi.pushNotice(payload);
            if (res.code === 200) {
                commit('mergeToInfo', { is_push_notice: payload ? 1 : 0 });
                commit('setNoticeTimer', Boolean(payload));
            }
        },

        /**
         * 注销用户
         */
        async disappear({ state, commit }, code) {
            const res = await userApi.disappear(code);
            if (res.code !== 200) {
                return res.msg;
            }
            commit('mergeToInfo', { disappear: 1 });
        },

        /**
         * 取消注销用户
         */
        async cancelDisappear({ commit }) {
            const res = await userApi.canalDisappear();
            if (res.code !== 200) {
                return res.msg;
            }
            commit('mergeToInfo', { disappear: 0 });
        },

        /**
         * 绑定手机号
         */
        async bindPhone({ dispatch }, { phone, code }) {
            const res = await userApi.bindPhone(phone, code);
            if (res.code === 200) {
                await dispatch('getUserInfo');
            }
            return res;
        },

        /**
         * 实名认证
         */
        async realName({ commit }, { realName, idNumber }) {
            const res = await userApi.realAuth(realName, idNumber);
            if (res.code === 200) {
                commit('mergeToInfo', { age_status: 1 });
            }
            return res;
        },
    },
};
